import React from "react";
import { Container } from "react-bootstrap"

export default function About(){
    return (<Container className="mt-5">
        <div>
        Attributes:<br></br> 
        icon: <a target="_blank" href='https://www.freepik.com/vectors/people'>People vector created by rawpixel.com - www.freepik.com</a>
        <br></br>
        icon: <a target="_blank" href='https://www.freepik.com/vectors/people'>People vector created by studiogstock - www.freepik.com</a>
        </div>
    </Container>)
}